"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useId } from "react";
import { Combobox, type ComboboxItem } from "@defuse/ui/combobox";
import { Label } from "@defuse/ui/label";
interface ReferralFilterProps {
  referral: string | undefined;
  referrals: ComboboxItem[];
  updateFilters: (filters: {
    referral: string | undefined;
  }) => void;
}
export function ReferralFilter(t0) {
  const $ = _c(12);
  const {
    referral,
    referrals,
    updateFilters
  } = t0;
  const id = useId();
  let t1;
  if ($[0] !== updateFilters) {
    t1 = value => {
      updateFilters({
        referral: value === "" ? undefined : value
      });
    };
    $[0] = updateFilters;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleValueChange = t1;
  let t2;
  if ($[2] !== id) {
    t2 = <Label htmlFor={id} className="text-muted-foreground text-xs">Referral</Label>;
    $[2] = id;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = referral ?? "";
  let t4;
  if ($[4] !== handleValueChange || $[5] !== id || $[6] !== referrals || $[7] !== t3) {
    t4 = <Combobox id={id} items={referrals} value={t3} onValueChange={handleValueChange} placeholder="Select a referral..." searchPlaceholder="Search referrals..." className="w-full" allowCustom={true} allowDeselect={true} />;
    $[4] = handleValueChange;
    $[5] = id;
    $[6] = referrals;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className="flex flex-col gap-1">{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}